import { toTitleCase } from 'common/utils';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import CustomDialog from 'components/dialogs/CustomDialog'
import { useAuth } from 'context/AuthContext';
import { useProfileContext } from 'context/ProfileContext';
import { useDeleteExperience } from 'hooks/useUsers';
import React, { useState } from 'react'
import { snackbarService } from 'services/snackbarService';

interface Props {
  open: boolean;
  setOpen: (value: boolean) => void;
  userId: number,
  positionId: number,
  entity: string; // Position | Experience
}

export default function DeletePositionDialog({
  open,
  setOpen,
  userId,
  positionId,
  entity,
}: Props) {
  const { refetch } = useProfileContext();

  const { mutate: deleteMutation, isLoading } = useDeleteExperience(
    (data: any) => {
      setOpen(false);
      snackbarService.showSnackbar(`${entity} has been deleted successfully`, 'success');
      refetch();
    },
    (error: any) => {
      console.log('error', error);
    },
  )

  const handleDelete = () => {
    deleteMutation({
      userId: userId,
      experienceId: positionId,
    });
  };


  return (
    <CustomDialog
      open={open}
      title={`Delete ${toTitleCase(entity)}`}
      message={`Are you sure you want to delete this ${entity}?`}
      buttons={[
        <CustomButton
          key='cancel'
          text='Cancel'
          variant='outlined'
          onClick={() => setOpen(false)}
          disabled={isLoading}
        />,
        <CustomButton
          key='delete'
          text='Delete'
          color='error'
          onClick={handleDelete}
          loading={isLoading}
        />
      ]}
    />
  )
}
